export default __webpack_public_path__ + "static/media/img-better-for-users.aa58c097.png";